import axios from 'utils/axios';

export const authPhoneToken = (phone: string, code: string, isEsia?: boolean) => {
  return axios.post(isEsia ? `/api/v1/registration/esia` : `/api/v1/auth/phones/token`, {
    phone,
    code,
  });
};
